export const EXPERTISE_TEXT = `Notre but est de vous offrir la maintenance la mieux adaptée aux besoins de votre moteur, pompes et groupes électrogènes et de vous garantir la fiabilité et longévité des travaux réalisés.`;
const STEP_1 = `Lavage, démontage et étuvage`;
const STEP_2 = `Bobinage moteur ( si nécessaire )`;
const STEP_3 = `Brulage, débobinage et rembobinage`;
const STEP_4 = `Vernis d'impregnation du stator et rotor`;
const STEP_5 = `Étuvage`;
const STEP_6 = `Équilibrage des pièces tournantes`;
const STEP_7 = `Rectification ou usinage des portées de roulements`;
const STEP_8 = `Vérification des collecteurs`;
const STEP_9 = `Remplacement des balais (si nécessaire )`;
const STEP_10 = `Remplacement des roulements et joints`;
const STEP_11 = `Essai du moteur à vide`;
const STEP_12 = `Mesures des grandeurs électriques`;
const STEP_13 = `Établissement d'un certificat de contrôle`;
const STEP_14 = `Finition peinture`;
export const STEP_LISTING = [
  STEP_1,
  STEP_2,
  STEP_3,
  STEP_4,
  STEP_5,
  STEP_6,
  STEP_7,
  STEP_8,
  STEP_9,
  STEP_10,
  STEP_11,
  STEP_12,
  STEP_13,
  STEP_14,
];
